import React, { Suspense } from 'react'
import PageLoader from '../../component/Elements/pageLoader'
import { lazyWithRetry } from '../../helper/lazyWithRetry'

const PickupMonitor = lazyWithRetry(() => import(/* webpackChunkName: "pickup-monitor" */'../../component/PickupMonitor'))

const PickupMonitorPage = React.memo(() => {
	return (
		<Suspense fallback={<PageLoader />}>
			<PickupMonitor />
		</Suspense>
	)
})

PickupMonitorPage.displayName = 'PickupMonitorPage'
export default PickupMonitorPage
